import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';

const milestones = [
  { year: '2018', title: '花生影院成立', desc: '由一群热爱电影的年轻人创立，致力于打造中文电影社区的新标杆。' },
  { year: '2019', title: '内容扩展', desc: '从最初的100部电影扩充到1000+部，涵盖全球主流电影资源。' },
  { year: '2020', title: '影评社区上线', desc: '开设专业影评栏目，邀请资深影评人入驻，为用户提供深度内容。' },
  { year: '2021', title: '日活突破10万', desc: '凭借优质内容和良好口碑，日均活跃用户突破10万大关。' },
  { year: '2022', title: '技术升级', desc: '全面优化播放体验，实现全平台高清流畅播放，加载速度提升300%。' },
  { year: '2023', title: '生态完善', desc: '构建完整的电影生态，涵盖资讯、影评、排行、社区等多元化服务。' },
  { year: '2025', title: '全新改版', desc: '品牌全面升级，以更优质的内容和更出色的体验服务千万影迷。' },
];

const testimonials = [
  {
    name: '张先生',
    role: '资深影迷',
    content: '花生影院是我每天必逛的网站，资源丰富更新快，不用缓冲这一点太赞了。影评栏目的文章质量也很高，帮我发现了很多好电影。',
    rating: 5,
  },
  {
    name: '李小姐',
    role: '电影专业学生',
    content: '作为电影专业的学生，花生影院的分类和排行功能对我帮助很大。特别是那些深度影评文章，给了我很多论文灵感。',
    rating: 5,
  },
  {
    name: '王先生',
    role: 'IT工程师',
    content: '下班后放松的首选就是花生影院。界面简洁干净，没有乱七八糟的广告，找电影很方便，体验非常好。',
    rating: 5,
  },
  {
    name: '刘女士',
    role: '全职妈妈',
    content: '周末和孩子们一起用花生影院看动画片，资源真的很多。分类清晰，给孩子找适合的电影也很方便。全家人都很喜欢。',
    rating: 4,
  },
];

const contactInfo = [
  { icon: 'ri-mail-line', label: '电子邮箱', value: 'contact@huashengcinema.com' },
  { icon: 'ri-phone-line', label: '客服电话', value: '400-888-6688' },
  { icon: 'ri-map-pin-line', label: '公司地址', value: '北京市朝阳区建国路88号SOHO现代城A座18层' },
  { icon: 'ri-time-line', label: '工作时间', value: '周一至周日 9:00 - 22:00' },
];

const faqs = [
  {
    q: '花生影院是否需要注册才能使用？',
    a: '不需要。花生影院所有功能均可免费使用，无需注册账号，无需付费，真正做到无障碍观影体验。',
  },
  {
    q: '花生影院的电影资源是否正版？',
    a: '花生影院严格遵守版权法规，所有资源均来自正规渠道合作方提供的授权内容，确保用户观影体验的合法性与安全性。',
  },
  {
    q: '为什么花生影院的播放如此流畅？',
    a: '我们采用了先进的CDN加速技术和智能码率自适应算法，根据用户的网络状况自动匹配最佳画质，确保在不同网络环境下都能获得流畅的观影体验。',
  },
  {
    q: '花生影院支持哪些设备观看？',
    a: '花生影院全面兼容PC、平板、手机等多种设备，无论在桌面端还是移动端，都能获得一致的高品质观影体验。',
  },
  {
    q: '如何向花生影院推荐电影资源？',
    a: '您可以通过我们的官方邮箱提交电影资源建议，我们的内容团队会认真审核每一条用户反馈，持续丰富平台资源库。',
  },
];

const aboutJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.huahuashengcinema.com/' },
        { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://www.huahuashengcinema.com/about' },
      ],
    },
    {
      '@type': 'Organization',
      name: '花生影院',
      url: 'https://www.huahuashengcinema.com',
      description: '花生影院成立于2018年，致力于为中文互联网用户提供最新、最全、最高品质的电影资源信息。',
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '400-888-6688',
        email: 'contact@huashengcinema.com',
        contactType: 'customer service',
        availableLanguage: 'Chinese',
      },
      address: {
        '@type': 'PostalAddress',
        streetAddress: '建国路88号SOHO现代城A座18层',
        addressLocality: '北京',
        addressRegion: '朝阳区',
        addressCountry: 'CN',
      },
    },
    {
      '@type': 'FAQPage',
      mainEntity: faqs.map((faq) => ({
        '@type': 'Question',
        name: faq.q,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.a,
        },
      })),
    },
    {
      '@type': 'WebPage',
      name: '关于我们 | 花生影院',
      url: 'https://www.huahuashengcinema.com/about',
      description: '了解花生影院的品牌故事、发展历程、用户口碑和联系方式。',
    },
  ],
};

export default function AboutPage() {
  return (
    <>
      <SEO
        title="关于我们 | 花生影院 - 品牌介绍与联系方式"
        description="花生影院成立于2018年，致力于打造一站式电影服务平台。了解我们的品牌故事、发展历程、用户口碑和联系方式。"
        keywords="花生影院,关于我们,品牌介绍,联系方式,电影网站"
        canonicalUrl="https://www.huahuashengcinema.com/about"
        ogType="website"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutJsonLd) }}
      />
      <Navbar />
      <main className="pt-16 md:pt-18">
        <nav className="px-4 md:px-6 lg:px-10 py-4 border-b border-background-300/20" aria-label="Breadcrumb">
          <div className="max-w-7xl mx-auto">
            <ol className="flex items-center gap-2 text-xs md:text-sm text-foreground-500">
              <li><Link to="/" className="hover:text-primary-400 transition-colors">首页</Link></li>
              <li><i className="ri-arrow-right-s-line text-xs"></i></li>
              <li className="text-foreground-300 font-medium">关于我们</li>
            </ol>
          </div>
        </nav>

        <section className="px-4 md:px-6 lg:px-10 py-12 md:py-20 text-center">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-50 mb-6">
              关于花生影院
            </h1>
            <p className="text-base md:text-lg text-foreground-400 leading-relaxed max-w-3xl mx-auto">
              花生影院成立于2018年，是一群热爱电影的年轻人共同打造的综合性电影服务平台。
              我们致力于为中文互联网用户提供最新、最全、最高品质的电影资源信息，
              打造一个集影片浏览、深度影评、热门排行为一体的一站式观影社区。
            </p>
          </div>
        </section>

        <section className="px-4 md:px-6 lg:px-10 py-12 md:py-16 bg-background-100/40">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-50 text-center mb-10 md:mb-12">
              发展历程
            </h2>
            <div className="relative">
              <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-300/40 md:-translate-x-px"></div>
              <div className="space-y-8 md:space-y-12">
                {milestones.map((item, i) => (
                  <div
                    key={item.year}
                    className={`relative flex flex-col md:flex-row gap-4 md:gap-8 ${
                      i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                    }`}
                  >
                    <div className={`flex-1 ${i % 2 === 0 ? 'md:text-right' : 'md:text-left'} pl-10 md:pl-0`}>
                      <div className="md:hidden absolute left-0 top-1 w-8 h-8 flex items-center justify-center rounded-full bg-primary-500/20 border-2 border-primary-500/40 z-10">
                        <div className="w-2.5 h-2.5 rounded-full bg-primary-500"></div>
                      </div>
                      <div className="hidden md:block flex-1"></div>
                    </div>
                    <div className="hidden md:flex absolute left-1/2 top-1 -translate-x-1/2 w-10 h-10 items-center justify-center rounded-full bg-primary-500/20 border-2 border-primary-500/40 z-10">
                      <div className="w-3 h-3 rounded-full bg-primary-500"></div>
                    </div>
                    <div className={`flex-1 pl-10 md:pl-0 ${i % 2 === 0 ? 'md:pl-8' : 'md:pr-8 md:text-right'}`}>
                      <span className="text-sm font-bold text-primary-400">{item.year}</span>
                      <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-100 mt-1 mb-1.5">
                        {item.title}
                      </h3>
                      <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="px-4 md:px-6 lg:px-10 py-12 md:py-16">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-50 text-center mb-2">
              用户口碑
            </h2>
            <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">听听我们的用户怎么说</p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
              {testimonials.map((item) => (
                <div
                  key={item.name}
                  className="p-5 md:p-6 rounded-xl bg-background-100/60 border border-background-300/20"
                >
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`text-sm ${i < item.rating ? 'ri-star-fill text-accent-400' : 'ri-star-line text-foreground-600'}`}
                      ></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-300 leading-relaxed mb-4">
                    {item.content}
                  </p>
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-full bg-primary-500/15 flex items-center justify-center text-primary-400 font-bold text-sm">
                      {item.name.charAt(0)}
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-200">{item.name}</p>
                      <p className="text-xs text-foreground-500">{item.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="px-4 md:px-6 lg:px-10 py-12 md:py-16 bg-background-100/40">
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12">
              <div>
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-50 mb-6">
                  联系我们
                </h2>
                <div className="space-y-4">
                  {contactInfo.map((item) => (
                    <div key={item.label} className="flex items-start gap-3">
                      <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-400">
                        <i className={`${item.icon} text-lg`}></i>
                      </div>
                      <div>
                        <p className="text-xs text-foreground-500 mb-0.5">{item.label}</p>
                        <p className="text-sm text-foreground-200 font-medium">{item.value}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-50 mb-6">
                  常见问题
                </h2>
                <div className="space-y-3">
                  {faqs.map((faq, i) => (
                    <details key={i} className="group">
                      <summary className="flex items-center justify-between p-4 rounded-xl bg-background-200/40 cursor-pointer hover:bg-background-200/60 transition-colors list-none">
                        <span className="text-sm font-medium text-foreground-200 pr-4">{faq.q}</span>
                        <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform flex-shrink-0"></i>
                      </summary>
                      <div className="px-4 pb-4">
                        <p className="text-sm text-foreground-500 leading-relaxed">{faq.a}</p>
                      </div>
                    </details>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}